import React, { useState, useEffect } from 'react'
import { Formik, Form, Field, FieldArray } from 'formik';
import FormikControl from '../../../hoc/formikComponents/FormikControl'
import { useMutation, useQuery } from 'react-query'
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance'
import Fetcher from '../../../hoc/FetcherSetting/FetcherSetting'
import { useParams } from 'react-router'
import { useHistory } from "react-router-dom";
import * as Yup from 'yup'
import { APIURL } from '../../../hoc/AxiosSetting/axios';
import axios from 'axios';


function AuditObservation() {
    const history = useHistory();
    const [initialValues, setInitialValues] = useState({
        id                      : "",
        orgCode                 : 0,
        companyName             : "",
        noOfTempLoc             : "",
        compliancestandard      : "",
        dateofaudit             : "",
        clearancedate           : new Date(),
        auditteam               : "",
        teamleader              : "",
        teamleaderName              : "",
        auditorOneName:"",
        auditorTwoName:"",

        justification           : "",
        remarkofstage           : "Yes",
        validationofprocesses   : "",
        commentbyauditor        : "Yes",
        productmanufacturing    : "",
        materialspecification   : "",
        fullyorpartially        : "",
        customerrequirements    : "",
        mrmconducted            : "",
        attendedby: "",
        managementfrequency: "",
        managementdate: new Date(),
        statusncclosing: "",
        nonconformity: "",
        frequency: "",
        dateia: new Date(),
        controlofprocess: "",
        relateddocuments: "",
        nacecode: "",
        effectivenumber: "",
        noOfShifts: "",
        total: "",
        repetitiveprocess: "",
        processdetails: "",
        regulatoryaspects: "",
        clientStatus:"",
        clientlocation: "",
        objectivestage: "",
        scopeofcertification: "",
        requirementsiso: "Yes",
        standardiso: "Yes",
        listedscope: "Yes",
        qualitymanagement: "Yes",
        compliancerequirements: "Yes",
        effectivemangement: "Yes",
        prerequisiteprogrammes: "Yes",
        processObservDetails: [{
                                    processNo: "",
                                    processName: "",
                                    nameOfAuditor: "",
                                    description: ""
                              }]
        })

    const onSubmit = (values, { setSubmitting, resetForm }) => {
  
                                    mutation.mutate(values)
    }

    const validationSchema = Yup.object({
        objectivestage          : Yup.string().required('Required').max(1000, 'Maximum 1000 Characters are allowed!!'),
        clientlocation          : Yup.string().required('Required').max(500, 'Maximum 500 Characters are allowed!!'),
        regulatoryaspects       : Yup.string().required('Required').max(100, 'Maximum 100 Characters are allowed!!'),
        processdetails          : Yup.string().required('Required').max(500, 'Maximum 500 Characters are allowed!!'),
        repetitiveprocess       : Yup.string().required('Required').max(100, 'Maximum 100 Characters are allowed!!'),
        relateddocuments        : Yup.string().required('Required').max(1000, 'Maximum 1000 Characters are allowed!!'),
        controlofprocess        : Yup.string().required('Required').max(1000, 'Maximum 1000 Characters are allowed!!'),
        frequency               : Yup.string().required('Required'),
        managementfrequency     :Yup.string().required('Required'),
        nonconformity           : Yup.string().required('Required'),
        statusncclosing         : Yup.string().required('Required'),
        customerrequirements    : Yup.string().required('Required').max(1000, 'Maximum 1000 Characters are allowed!!'),
        fullyorpartially        : Yup.string().required('Required').max(1000, 'Maximum 1000 Characters are allowed!!'),
        materialspecification   : Yup.string().required('Required').max(1000, 'Maximum 1000 Characters are allowed!!'),
        productmanufacturing    : Yup.string().required('Required').max(1000, 'Maximum 1000 Characters are allowed!!'),
        justification           : Yup.string().required('Required').max(1000, 'Maximum 1000 Characters are allowed!!'),
        validationofprocesses   : Yup.string().required('Required').max(100, 'Maximum 100 Characters are allowed!!'),
        clientStatus            : Yup.string().required('Required').max(100, 'Maximum 100 Characters are allowed!!'),
        dateia                  :Yup.string().required('Required')
       
    })

    const { orgcode } = useParams()

    // const { data: Rfqdata, isLoading: rfqLoading } = useQuery(
    //     'listrfq',
    //     () => Fetcher('get', '/api/rfq/get/orgdetails/' + orgcode, {}))

    // useEffect(() => {
    //     if (Rfqdata && initialValues.orgCode === 0) {
    //         var tempData = Rfqdata.data.response
    //         // tempData.dateofaudit = moment(tempData.dateofaudit).format('DD-MMM-YYYY');
    //         tempData.dateia = Date.parse(tempData.dateia);
    //         tempData.internalaudit = Date.parse(tempData.internalaudit);
    //         tempData.mrmconducted = Date.parse(tempData.mrmconducted);
    //         tempData.clearancedate = Date.parse(tempData.clearancedate);
    //         tempData.managementdate = Date.parse(tempData.managementdate);
    //         tempData.dateofaudit = Date.parse(tempData.dateofaudit)
    //         setInitialValues(tempData)
    //     }
    // }, [orgcode && !rfqLoading && initialValues.orgCode === 0])

    const getUrl = () =>{
        const api= APIURL + '/api/rfq/get/orgdetails/' +orgcode
        axios.get(api , { headers: {"Authorization" : 'Bearer ' + localStorage.getItem("token")} })
        .then(Rfqdata=>{
            if (Rfqdata && initialValues.orgCode === 0 && Rfqdata.data.response.auditPlanStatus=== true) {
                var tempData = Rfqdata.data.response
                tempData.dateia = Date.parse(tempData.dateia);
                tempData.internalaudit = Date.parse(tempData.internalaudit);
                tempData.mrmconducted = Date.parse(tempData.mrmconducted);
                tempData.clearancedate = Date.parse(tempData.clearancedate);
                tempData.managementdate = Date.parse(tempData.managementdate);
                tempData.dateofaudit = Date.parse(tempData.dateofaudit)
                setInitialValues(tempData)
            }
        })
        .catch(err=>{
            var string= JSON.stringify(err).split("/")[0]
            const regex = /401/g;
            const found = string.match(regex);
            
            console.log("found",found);
            if(found !== null){
                console.log(err)
                // window.location.href = "/signin"
            }
        })
    }
   
    useEffect(() => {
        if(orgcode!== undefined){
            getUrl()
        }
       
    }, [orgcode!== undefined])

    const mutation = useMutation((params) => Fetcher('patch', '/api/rfq/patch/auditobservation', params), {
        onSuccess(data) {
            if (data.data.errorCode === 0) {
                ToastInstance('Success', 'Audit Observation Added')
                history.push("/"+localStorage.getItem("role")+'/viewauditobservation/' + data.data.response.orgCode);

            } else {
                var msg = 'Audit Observation - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.error('Got error from backend', error)
            ToastInstance('Error', 'Audit Observation' + error)
        }
    })

    const gpPvtHealthSubCenterOptions = [
        { key: 'Yes', value: 'Yes' },
        { key: 'No', value: 'No' }
    ]

  const frequencyOption =[
    { key: 'Select', value: 'Select' }, 
    { key: 'Weekly', value: 'Weekly' }, 
    { key: 'ByMonthly', value:'ByMonthly' }, 
    { key: 'Monthly', value: 'Monthly' }, 
    { key: 'Quarterly', value: 'Quarterly' }, 
    { key: 'Half Yearly', value: 'Half Yearly' }, 
    { key: 'Yearly', value: 'Yearly' }, 
  ]
    const mutationgetCompanyDetails = useMutation((params) => Fetcher('get', '/api/rfq/get/orgdetails/' + params, {}), {
        onSuccess(data) {
            if (data.data.errorCode === 0) {
                var tempInitialValues = data.data.response;
                console.log("tempInitialValues", tempInitialValues)
                tempInitialValues.nacecode = data.data.response.nacecode || "";
                tempInitialValues.effectivenumber = data.data.response.effectiveNoEmpToBeAudited || "";
                tempInitialValues.noOfShifts = data.data.response.noOfShifts || "";
                tempInitialValues.total = data.data.response.total || "";
                tempInitialValues.dateofaudit = Date.parse(data.data.response.dateofaudit) || null;
                tempInitialValues.dateia = Date.parse(data.data.response.dateia) || null;
                tempInitialValues.clearancedate = Date.parse(data.data.response.clearancedate) || null;
                tempInitialValues.managementdate = Date.parse(data.data.response.managementdate) || null;
                tempInitialValues.internalaudit = Date.parse(data.data.response.internalaudit) || null;
                tempInitialValues.mrmconducted = Date.parse(data.data.response.mrmconducted) || null;
                tempInitialValues.auditteam = data.data.response.auditteam || "";
                tempInitialValues.teamleaderName = data.data.response.teamleaderName || "";
                tempInitialValues.teamleader = data.data.response.teamleader || "";
                tempInitialValues.scopeofcertification = data.data.response.scope || "";
                tempInitialValues.requirementsiso = data.data.response.requirementsiso || "Yes";
                tempInitialValues.standardiso = data.data.response.standardiso || "Yes";
                tempInitialValues.listedscope = data.data.response.listedscope || "Yes";
                tempInitialValues.qualitymanagement = data.data.response.qualitymanagement || "Yes";
                tempInitialValues.compliancerequirements = data.data.response.compliancerequirements || "Yes";
                tempInitialValues.effectivemangement = data.data.response.effectivemangement || "Yes";
                tempInitialValues.prerequisiteprogrammes = data.data.response.prerequisiteprogrammes || "Yes";
                tempInitialValues.commentbyauditor = data.data.response.commentbyauditor || "Yes";
                tempInitialValues.remarkofstage = data.data.response.remarkofstage || "Yes";
                tempInitialValues.processObservDetails = data.data.response.processObservDetails.length > 0 ? data.data.response.processObservDetails : [{
                    processNo: "",
                    processName: "",
                    nameOfAuditor: "",
                    description: ""

                }]
                setInitialValues(tempInitialValues)
            } else {
                var msg = 'Company - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Get Company Details' + error)
        }
    })
    const { data: auditorList, isLoading: auditorListLoading } = useQuery(
        'listauditor',
        () => Fetcher('get', '/api/auditormaster/get/valuelabelforauditor', {}))
    console.log("Auditor", auditorList)



    const { data: OrgList, isLoading: orgLoading } = useQuery(
        'listorg',
        () => Fetcher('get', '/api/clientaccess/get/listofcompaniesofplaneddata/'+ localStorage.getItem("userCode"), {}))

    if (orgLoading || auditorListLoading) return <h1>Loading</h1>
    if (orgcode && initialValues.orgCode === 0){
        window.location.href = "/signin"
        return <h1>Loading Data</h1>
       
     }
    return (
        <div>
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}

            >
                {
                    formik => <Form>
                        <div className="content-wrapper">
                            <section className="content">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-sm-12">

                                                        <div className="formOuterDiv">

                                                            <div className="form1RowDiv">
                                                                <FormikControl control='selectNACECode' name='orgCode' options={OrgList.data.response} type="text" label='Client Name' onChange={e => { mutationgetCompanyDetails.mutate(e.value); }} />
                                                            </div>

                                                            <div className="form1RowDiv">
                                                                <FormikControl control='textarea' type='text' label='Address' name='address' disabled={true} />
                                                            </div>

                                                            <div className="form1RowDiv">
                                                                <FormikControl control='textarea' type='text' label='Scope of certification' name='scopeofcertification' disabled={true} />
                                                            </div>

                                                            <div className="form1RowDiv">
                                                                <FormikControl control='input' type='text' label='Objectives of Stage 1 audit *' name='objectivestage' />
                                                            </div>

                                                            <div className="form2RowDiv">
                                                                <FormikControl control='input' type='text' label='Number of sites' name='nosites' disabled={true} className="text-right"/>
                                                                <FormikControl control='input' type="text" label='Lead Auditor/Auditor' name='teamleaderName' disabled={true} />
                                                            </div>

                                                        <div className="form2RowDiv">
                                                            <FormikControl control='input' type='text' label='Compliance Standard' name='typeOfCertification' disabled={true}  />
                                                            <FormikControl control='date' type="text" label='Date of Audit' name='dateofaudit' disabled={true} dateFormat="dd-MM-yyyy"/>
                                                        </div>

                                                        <div className="form2RowDiv">
                                                            <FormikControl control='date' type='text' label='Clearance date *' name='clearancedate'   dateFormat="dd-MM-yyyy"/>
                                                         
                                                        </div>
                                                      
                                                        <div className="hrstyle headingcolor">
                                                            <h5>Audit Team</h5>
                                                        </div>

                                                    <div className="form2RowDiv">
                                                            {/* <FormikControl control="selectNACECode" name="teamleaderName" label="Team Leader/ Lead Auditor" options={auditorList.data.response}
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(`teamleader`, e.value)
                                                                    formik.setFieldValue(`teamleaderName`, e.label)
                                                                }}
                                                                disabled={true}/> */}
                                                                 <FormikControl control='input' type='text' label='Team Leader/ Lead Auditor' name='teamleaderName' disabled={true}/>

                                                        <FormikControl control='input' type='text' label='Technical expert' name='technicalExpertName' disabled={true}/>

                                                    </div>

                                                    <div className="form2RowDiv">
                                                        <FormikControl control='input' type='text' label='Auditor One' name='auditorOneName' disabled={true}/>
                                                        <FormikControl control='input' type='text' label='Auditor Two' name='auditorTwoName' disabled={true}/>
                                                        </div>

                                                           

                                                            <div className="hrstyle headingcolor">
                                                                <h5 >The first stage of the audit has taken place to confirm that the organisation has:</h5>
                                                            </div>



                                                            <div className="row" style={{marginLeft:"0.4%"}}>
                                                                
                                                                <label htmlFor="staticEmail" className="col-sm-9 mt-4">A sufficient understanding with regard to the requirements of ISO 9001:2015 </label>
                                                                <div className="col-sm-2 mt-4">
                                                                    <FormikControl control='radio' name='requirementsiso' options={gpPvtHealthSubCenterOptions} />
                                                                </div>

                                                                <label htmlFor="staticEmail" className="col-sm-9 mt-4">Documented information as required by the standard ISO 9001:2015</label>
                                                                <div className="col-sm-2 mt-4">
                                                                    <FormikControl control='radio' name='standardiso' options={gpPvtHealthSubCenterOptions} />
                                                                </div>

                                                                <label htmlFor="staticEmail" className="col-sm-9 mt-4">Suitable premises for the provision of the products/service listed in the scope</label>
                                                                <div className="col-sm-2 mt-4">
                                                                    <FormikControl control='radio' name='listedscope' options={gpPvtHealthSubCenterOptions} />
                                                                </div>

                                                                <label htmlFor="staticEmail" className="col-sm-9 mt-4">Employed suitable expertise in preparing the Quality Management System</label>
                                                                <div className="col-sm-2 mt-4">
                                                                    <FormikControl control='radio' name='qualitymanagement' options={gpPvtHealthSubCenterOptions} />
                                                                </div>

                                                                <label htmlFor="staticEmail" className="col-sm-9 mt-4">Identified necessary statutory and regulatory and compliance requirements.</label>
                                                                <div className="col-sm-2 mt-4">
                                                                    <FormikControl control='radio' name='compliancerequirements' options={gpPvtHealthSubCenterOptions} />
                                                                </div>

                                                                <label htmlFor="staticEmail" className="col-sm-9 mt-4">An effective management review and internal audit system in place</label>
                                                                <div className="col-sm-2 mt-4">
                                                                    <FormikControl control='radio' name='effectivemangement' options={gpPvtHealthSubCenterOptions} />
                                                                </div>

                                                                <label htmlFor="staticEmail" className="col-sm-9 mt-4">Appropriate pre-requisite programmes for stage 2 audit in place</label>
                                                                <div className="col-sm-2 mt-4">
                                                                    <FormikControl control='radio' name='prerequisiteprogrammes' options={gpPvtHealthSubCenterOptions} />
                                                                </div>
                                                            </div>


                                                            <div className="form1RowDiv mt-4">
                                                                <FormikControl control='textarea' type='text' label='Clients’ location & site-specific conditions *' name='clientlocation' />
                                                            </div>
                                                            <div className="hrstyle headingcolor">
                                                                <h5 >Organization structure:</h5>
                                                            </div>

                                                            <div className="form2RowDiv">
                                                                <FormikControl control='input' type='text' label='Process Details *'  name='processdetails' />
                                                                <FormikControl control='input' type="text" label='Repetitive Process *' name='repetitiveprocess' />
                                                            </div>


                                                            <div className="form2RowDiv">
                                                                <FormikControl control='input' type='text' label='No. of employees' name='total' disabled={true} />
                                                                <FormikControl control='input' type="text" label='No. of shifts' name='noOfShifts' disabled={true} />
                                                            </div>

                                                            <div className="form2RowDiv">
                                                                <FormikControl control='input' type='text' label='Effective Number of Employees to Audited' name='effectivenumber' disabled={true}/>
                                                                <FormikControl control='input' type="text" label='Scope of certification & ANZ-SIC code/ NACE code' name='nabcbcodeName' disabled={true} />

                                                            </div>
                                                            <hr className="mt-3" />

                                                            <div className="form1RowDiv">
                                                                <FormikControl control='textarea' type='text' label='Statutory & Regulatory aspects (quality, environmental & legal) *' name='regulatoryaspects' />
                                                            </div>
                                                            <div className="form1RowDiv">
                                                                <FormikControl control='textarea' type='text' label='Clients status and understanding regarding requirements of the standard *' name='clientStatus' />
                                                            </div>


                                                            

                                                           

                                                            <div className="form1RowDiv">
                                                                <FormikControl control='textarea' type='text' label='7.5 Related documented information include
                                                                    a.Documented information as required by standard
                                                                    b.Quality Policy
                                                                    c.Quality Objectives *' name='relateddocuments' />
                                                            </div>


                                                            <div className="form1RowDiv">
                                                                <FormikControl control='input' type='text' label='Control of externally provided Processes, Products & Services and control there of *' name='controlofprocess' />
                                                            </div>

                                                            <div className="hrstyle headingcolor">
                                                                <h5 >Internal audit conducted:</h5>
                                                            </div>

                                                            <div className="form2RowDiv">
                                                                <FormikControl control='date' type='text' label='Date of last IA *' name='dateia' dateFormat="dd-MM-yyyy" />
                                                                <FormikControl control='select' type="text" label='Frequency *' name='frequency' options={frequencyOption} />
                                                            </div>

                                                            <div className="form2RowDiv">
                                                                <FormikControl control='input' type='text' label='Non conformity *' name='nonconformity'  />
                                                                <FormikControl control='input' type="text" label='Status of NC closing *' name='statusncclosing' />
                                                            </div>

                                                            <div className="form2RowDiv">
                                                            <FormikControl control='date' type='text' label='Previous Internal Audit Conducted on' name='internalaudit' dateFormat="dd-MM-yyyy" />
                                                                {/* <FormikControl control='input' type='text' label='Previous Internal Audit Conducted on ' name='internalaudit' /> */}
                                                            </div>


                                                            <div className="hrstyle headingcolor">
                                                                <h5 >Management Review conducted(MRM):</h5>
                                                            </div>


                                                            <div className="form2RowDiv">
                                                                <FormikControl control='date' type='text' label='Date *' dateFormat="dd-MM-yyyy" name='managementdate' />
                                                                {/* <FormikControl control='input' type="text" label='Frequency' name='managementfrequency' /> */}
                                                                <FormikControl control='select' type="text" label='Frequency *' name='managementfrequency' options={frequencyOption} />

                                                            </div>

                                                            <div className="form2RowDiv">
                                                                <FormikControl control='input' type='text' label='Attended by *' name='attendedby' />
                                                                <FormikControl control='date' type='text' label='Previous MRM Conducted on' name='mrmconducted' dateFormat="dd-MM-yyyy" />

                                                               
                                                            </div>


                                                            {/* <div className="hrstyle headingcolor">
                                                                <h5 >Process Details:</h5>
                                                            </div> */}
                                                            {/* <div className="fieldarray">

                                                                <FieldArray name='processObservDetails'>

                                                                    {fieldArrayProps => {
                                                                        const { push, remove, form } = fieldArrayProps
                                                                        const { values } = form
                                                                        const { processObservDetails } = values
                                                                        return (
                                                                            <div>
                                                                                {processObservDetails.map((processDetail, index) => (
                                                                                    <div key={index}>
                                                                                        <div className="form2RowDiv">
                                                                                            {index > 0 && (
                                                                                                <div className="col-sm-1">
                                                                                                    <span style={{ "marginLeft": "1050px", "cursor": "pointer" }} onClick={() => remove(index)}><AiIcons.AiOutlineDelete style={{ widh: "50px", color: "red" }} /></span>
                                                                                                </div>
                                                                                            )}

                                                                                            <div className="formSingleElement">
                                                                                                <label className="formSingleElementLabel">Process Number</label>
                                                                                                <Field className="form-control" name={`processObservDetails[${index}].processNo`} />
                                                                                            </div>
                                                                                            <div className="formSingleElement">
                                                                                                <label className="formSingleElementLabel">Process Name</label>
                                                                                                <Field className="form-control" name={`processObservDetails[${index}].processName`} />
                                                                                            </div>
                                                                                        </div>


                                                                                        <div className="form2RowDiv ">
                                                                                            <div className="formSingleElement">
                                                                                             
                                                                                                 <FormikControl control="selectNACECode" name={`processObservDetails[${index}].nameOfAuditor`}  options={auditorList.data.response} label='Name Of Auditor' 
                                                                                               onChange={(e) => {
                                                                                                var tempData = auditorList.data.response
                                                                                                var processObservDetailsResponse = tempData.find(x => (x._id) === (e.value))
                                                                                                formik.setFieldValue(`processObservDetails[${index}].nameOfAuditor`, processObservDetailsResponse.nameOfAuditor)
                                                                                            }
                                                                                            } />

                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="row mt-4" style={{margin:"1%"}}>

                                                                                            <div className="col-sm-11">
                                                                                                <label htmlFor="staticEmail" className="col-sm-5 mt-1 mb-1">Description</label>
                                                                                                <FormikControl control='ckEditor' name={`processObservDetails[${index}].description`} className="form-control" data={initialValues.processObservDetails.description} />


                                                                                            </div>
                                                                                        </div>



                                                                                    </div>

                                                                                ))}


                                                                                <div className="row mt-3">
                                                                                    <div className="col-lg-11"></div>
                                                                                    <div className="col-lg-1 mb-3" >
                                                                                        <button type='button' className="btn btn-primary" onClick={() => push('')}>Add</button>
                                                                                    </div>
                                                                                </div>


                                                                            </div>

                                                                        )
                                                                    }}
                                                                </FieldArray>
                                                            </div> */}

                                                            <div className="hrstyle headingcolor">
                                                                <h5 >Verification of Design & Development</h5>
                                                            </div>

                                                            <div className="form1RowDiv">
                                                                <FormikControl control='input' type='text' label='Check the customer requirements as per the given scope *' name='customerrequirements' />
                                                            </div>

                                                            <div className="form1RowDiv">
                                                                <FormikControl control='input' type='text' label='Product / Service specification (provided by customer (fully or partially ) *' name='fullyorpartially' />
                                                            </div>

                                                            <div className="form1RowDiv">
                                                                <FormikControl control='input' type='text' label='Who decides Material specification / properties , product parameter s and Inspection & testing parameters (where it is appropriate) *' name='materialspecification' />
                                                            </div>

                                                            <div className="form1RowDiv">
                                                                <FormikControl control='input' type='text' label='Look for support process for product manufacturing (such as tool design, bought out / child part in case of assembly) *' name='productmanufacturing' />
                                                            </div>

                                                            <div className="form1RowDiv">
                                                                <FormikControl control='input' type='text' label='Justification *' name='justification' />
                                                            </div>


                                                            <div className="row mt-3">
                                                                <label htmlFor="staticEmail" className="col-sm-9">Comment by auditor -  Design applicable YES / NO </label>
                                                                <div className="col-sm-2">
                                                                    <FormikControl control='radio' name='commentbyauditor' options={gpPvtHealthSubCenterOptions} />
                                                                </div>
                                                            </div>

                                                            <hr />

                                                            <div className="form1RowDiv">
                                                                <FormikControl control='input' type='text' label='8.5.1 Applicability for Validation of processes and records there of *' name='validationofprocesses' />
                                                            </div>


                                                            <div className="row mt-4">
                                                                <label htmlFor="staticEmail" className="col-sm-9"><strong>REMARK:</strong>The objectives of Stage 1 Audit have been achieved (tick )</label>
                                                                <div className="col-sm-2">
                                                                    <FormikControl control='radio' name='remarkofstage' options={gpPvtHealthSubCenterOptions} />
                                                                </div>
                                                            </div>

                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </section>
                           
                            <div className="card-footer">
                                <div className="row">
                                    <div className="col-sm-10"></div>
                                    <div className="col-sm-2">
                                        <button type="submit" className="btn btn-primary float-right" disabled={!formik.isValid}>Submit</button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </Form>
                }
            </Formik>
        </div>
    )
}

export default AuditObservation
